export default {
    data() {
        return {
            // refresh variables
            refreshing: false,
            registration: null,
            updateExists: false,
        }
    },

    created() {
        // Listen for our custom event from the SW registration
        document.addEventListener(
            'swUpdated',
            this.updateAvailable,
            { once: true }
        )
    },

    beforeDestroy() {
        document.removeEventListener(
            'swUpdated',
            this.updateAvailable
        )
    },

    methods: {
        // Store the SW registration so we can send it a message.
        // We use `updateExists` to control whatever alert, toast,
        // dialog, etc. we want to use to notify the user.
        updateAvailable(event) {
            this.registration = event.detail
            this.updateExists = true

            console.log("THERES AN UPDATE AVAILABLE")
        },

        // Called when the user accepts the update
        refreshApp() {
            console.log("USER ACCEPTED THE UPDATE")

            this.updateExists = false

            // Make sure we only send a 'skip waiting' message
            // if the SW is waiting.
            if (
                !this.registration ||
                !this.registration.waiting
            ) {
                return
            }

            // Send message to SW to skip the waiting
            // and activate the new service worker.
            this.registration.waiting.postMessage({
                type: 'SKIP_WAITING'
            })
        },
    },
}